import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_MANHOLE_COUNT = 'GET_MANHOLE_COUNT'
export const getManholeCount = (type) => {
  return (dispatch, getState) => {
    let status = 'Open'
    if (type === 'closed') {
      status = 'Closed'
    }
    dispatch(createAction(GET_MANHOLE_COUNT)())
    const options = {}
    const where = { status }
    const clientId = getClientId(getState)
    where.clientId = clientId
    options.where = where
    sendApiRequest('Manholes/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getManholeCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getManholeCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_MANHOLE_COUNT_SUCCESS = 'GET_MANHOLE_COUNT_SUCCESS'
export const getManholeCountSuccess = createAction(GET_MANHOLE_COUNT_SUCCESS)

export const GET_MANHOLE_COUNT_ERROR = 'GET_MANHOLE_COUNT_ERROR'
export const getManholeCountError = createAction(GET_MANHOLE_COUNT_ERROR)

export const GET_MANHOLES = 'GET_MANHOLES'
export const getManholes = (pageSize, pageNumber, type) => {
  return (dispatch, getState) => {
    let status = 'Open'
    if (type === 'closed') {
      status = 'Closed'
    }
    const options = {
      filter: {
        order: 'createdAt DESC',
        where: { status }
      }
    }
    if (pageSize !== 0) {
      options.filter.limit = pageSize + 1
    }
    if (pageNumber !== 1) {
      options.filter.skip = (pageNumber - 1) * pageSize
    }
    const clientId = getClientId(getState)
    options.filter.where.clientId = clientId
    dispatch(createAction(GET_MANHOLES)())
    sendApiRequest('Manholes', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getManholesError(response))
      }
      if (response.status === 'success') {
        dispatch(getManholesSuccess(response.data))
      }
    })
  }
}

export const GET_MANHOLES_SUCCESS = 'GET_MANHOLES_SUCCESS'
export const getManholesSuccess = createAction(GET_MANHOLES_SUCCESS)

export const GET_MANHOLES_ERROR = 'GET_MANHOLES_ERROR'
export const getManholesError = createAction(GET_MANHOLES_ERROR)

export const GET_MANHOLE_BY_ID = 'GET_MANHOLE_BY_ID'
export const getManholeById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_MANHOLE_BY_ID)())
    sendApiRequest(`Manholes/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getManholeByIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getManholeByIdSuccess(response.data))
      }
    })
  }
}

export const GET_MANHOLE_BY_ID_SUCCESS = 'GET_MANHOLE_BY_ID_SUCCESS'
export const getManholeByIdSuccess = createAction(GET_MANHOLE_BY_ID_SUCCESS)

export const GET_MANHOLE_BY_ID_ERROR = 'GET_MANHOLE_BY_ID_ERROR'
export const getManholeByIdError = createAction(GET_MANHOLE_BY_ID_ERROR)

export const GET_MANHOLE_BY_ID_RESET = 'GET_MANHOLE_BY_ID_RESET'
export const getManholeByIdReset = createAction(GET_MANHOLE_BY_ID_RESET)

export const DELETE_MANHOLE_BY_ID = 'DELETE_MANHOLE_BY_ID'
export const deleteManholeById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_MANHOLE_BY_ID)())
    sendApiRequest(`Manholes/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteManholeByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteManholeByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_MANHOLE_BY_ID_SUCCESS = 'DELETE_MANHOLE_BY_ID_SUCCESS'
export const deleteManholeByIdSuccess = createAction(DELETE_MANHOLE_BY_ID_SUCCESS)

export const DELETE_MANHOLE_BY_ID_ERROR = 'DELETE_MANHOLE_BY_ID_ERROR'
export const deleteManholeByIdError = createAction(DELETE_MANHOLE_BY_ID_ERROR)

export const DELETE_MANHOLE_BY_ID_RESET = 'DELETE_MANHOLE_BY_ID_RESET'
export const deleteManholeByIdReset = createAction(DELETE_MANHOLE_BY_ID_RESET)

// export const CREATE_NEW_MANHOLE = 'CREATE_NEW_MANHOLE'
// export const createNewManhole = (data) => {
//   return (dispatch, getState) => {
//     dispatch(createAction(CREATE_NEW_MANHOLE)())
//     const manholeData = data
//     manholeData.accessToken = getState().auth.account.accessToken
//     sendApiRequest(`Manholes`, manholeData, 'post').then((response) => {
//       if (response.status === 'failure') {
//         dispatch(createNewManholeError(response))
//       }
//       if (response.status === 'success') {
//         dispatch(createNewManholeSuccess(response.data))
//       }
//     })
//   }
// }

export const CREATE_NEW_MANHOLE_SUCCESS = 'CREATE_NEW_MANHOLE_SUCCESS'
export const createNewManholeSuccess = createAction(CREATE_NEW_MANHOLE_SUCCESS)

export const CREATE_NEW_MANHOLE_ERROR = 'CREATE_NEW_MANHOLE_ERROR'
export const createNewManholeError = createAction(CREATE_NEW_MANHOLE_ERROR)

export const EDIT_MANHOLE = 'EDIT_MANHOLE'
export const editManhole = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_MANHOLE)())
    const manholeData = data
    manholeData.accessToken = getState().auth.account.accessToken
    sendApiRequest(`Manholes/${data.mucId}`, manholeData, 'patch').then((response) => {
      if (response.status === 'failure') {
        dispatch(createNewManholeError(response))
      }
      if (response.status === 'success') {
        dispatch(createNewManholeSuccess(response.data))
      }
    })
  }
}

export const RESET_MANHOLE_FORM = 'RESET_MANHOLE_FORM'
export const resetManholeForm = createAction(RESET_MANHOLE_FORM)

const initialState = {
  manholeCount: 0,
  isGettingManholes: false,
  hasGottenManholes: false,
  manholes: [],
  getManholesError: {},
  selectedManhole: {},
  isGettingManhole: false,
  hasGottenManhole: false,
  getManholeError: {},
  isDeletingManhole: false,
  hasDeletedManhole: false,
  deleteManholeSuccess: {},
  deleteManholeError: {},
  isCreatingManhole: false,
  hasCreatedManhole: false,
  createManholeSuccess: {},
  createManholeError: {}
}

export default handleActions({

  [GET_MANHOLE_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    manholeCount: payload
  }),

  [GET_MANHOLES]: (state) => ({
    ...state,
    isGettingManholes: true,
    hasGottenManholes: false
  }),

  [GET_MANHOLES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingManholes: false,
      hasGottenManholes: true,
      manholes: payload
    }
  },

  [GET_MANHOLES_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingManholes: false,
      hasGottenManholes: false,
      getManholesError: payload
    }
  },

  [GET_MANHOLE_BY_ID]: (state) => ({
    ...state,
    isGettingManhole: true,
    hasGottenManhole: false
  }),

  [GET_MANHOLE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingManhole: false,
      hasGottenManhole: true,
      selectedManhole: payload
    }
  },

  [GET_MANHOLE_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingManhole: false,
      hasGottenManhole: false,
      getManholeError: payload
    }
  },
  [GET_MANHOLE_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingManhole: false,
    hasGottenManhole: false,
    selectedManhole: {}
  }),

  [DELETE_MANHOLE_BY_ID]: (state) => ({
    ...state,
    isDeletingManhole: true,
    hasDeletedManhole: false
  }),

  [DELETE_MANHOLE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingManhole: false,
      hasDeletedManhole: true,
      deleteManholeSuccess: payload
    }
  },

  [DELETE_MANHOLE_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingManhole: false,
      hasDeletedManhole: false,
      deleteManholeError: payload
    }
  },

  [DELETE_MANHOLE_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingManhole: false,
      hasDeletedManhole: false,
      deleteManholeError: {},
      deleteManholeSuccess: {}
    }
  },

  // [CREATE_NEW_MANHOLE]: (state, { payload }) => {
  //   return {
  //     ...state,
  //     isCreatingManhole: true,
  //     hasCreatedManhole: false,
  //     createManholeSuccess: {},
  //     createManholeError: {}
  //   }
  // },

  [CREATE_NEW_MANHOLE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingManhole: false,
      hasCreatedManhole: true,
      createManholeSuccess: payload
    }
  },

  [CREATE_NEW_MANHOLE_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isCreatingManhole: false,
      hasCreatedManhole: false,
      createManholeError: payload
    }
  },

  [EDIT_MANHOLE]: (state) => {
    return {
      ...state,
      isCreatingManhole: true,
      hasCreatedManhole: false,
      createManholeSuccess: {},
      createManholeError: {}
    }
  },

}, initialState)
